var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg8 = function Svg8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5969",
    fillRule: "evenodd",
    d: "M4.5 21.75a2.25 2.25 0 0 1-2.25-2.25v-15A2.25 2.25 0 0 1 4.5 2.25h15a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25zM3.75 4.5a.75.75 0 0 1 .75-.75h6.75v16.5H4.5a.75.75 0 0 1-.75-.75zM19.5 20.25a.75.75 0 0 0 .75-.75v-3.75h-7.5v4.5zm-6.75-16.5h6.75a.75.75 0 0 1 .75.75v3.75h-7.5zm0 10.5h7.5v-4.5h-7.5z",
    clipRule: "evenodd"
  })));
};
export default Svg8;